import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldHalved } from '@fortawesome/free-solid-svg-icons';
import { GUARANTEE_BODY, GUARANTEE_HEADLINE } from './courseContent';
import './courseKit.css';

/**
 * Risk reversal, given its own bordered block next to the price.
 *
 * Hormozi's point is that the guarantee should be one of the loudest things on
 * the page, not a footnote, because it removes the reason to delay.
 */
const GuaranteeBlock = ({ compact = false, description = GUARANTEE_BODY }) => (
  <aside
    className={`ck-guarantee ${compact ? 'is-compact' : ''}`.trim()}
    data-testid="guarantee-block"
  >
    <span className="ck-guarantee-badge" aria-hidden="true">
      <FontAwesomeIcon icon={faShieldHalved} />
    </span>
    <div>
      <strong>{GUARANTEE_HEADLINE}</strong>
      <p>{description}</p>
    </div>
  </aside>
);

export default GuaranteeBlock;
